import { Injectable } from '@angular/core';
import { Router, Params, ActivatedRoute, ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Users } from './users.model';
import { UsersService } from './users.service';


@Injectable()
export class UsersListGuard implements Resolve<Users> {

  constructor(public router: Router, private usersService: UsersService) { }

  resolve() {
    return this.usersService.getUsersList();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/users/users-list.guard.ts